import acmeSite from '../acmeSite';
import coffeehouseSite from '../coffeehouseSite';
import defaultSite from '../defaultSite';
import lamanteSite from '../lamanteSite';
import showcaseSite from '../showcaseSite';
import { SiteDefinition } from '../SiteDefinition';

const registry: Record<string, SiteDefinition> = {
    [defaultSite.id]: defaultSite,
    [showcaseSite.id]: showcaseSite,
    [lamanteSite.id]: lamanteSite,
    [acmeSite.id]: acmeSite,
    [coffeehouseSite.id]: coffeehouseSite,
};

export default registry;
